import { render, staticRenderFns } from "./checkScreen.vue?vue&type=template&id=0f859ab6&scoped=true"
import script from "./checkScreen.vue?vue&type=script&lang=js"
export * from "./checkScreen.vue?vue&type=script&lang=js"
import style0 from "./checkScreen.vue?vue&type=style&index=0&id=0f859ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f859ab6",
  null
  
)

export default component.exports